@if (result) {
<div class="grid-x grid-margin-x headline-wrapper fernwaerme">
  <section class="cell small-12 large-offset-2 large-8 result">
    @if (result !== 'nein') {
      <h1 class="text-center" [innerHTML]="textkeyPrefix + 'headline' + textkeyPostfix | translate"></h1>
    }
    @if (result !== 'keine_adresse') {
      <strong [innerHTML]="textkeyPrefix + 'result' + textkeyPostfix | translate"></strong>
    }
    <div class="callout secondary">
      <app-advisor-image [path]="'/moc/portal_logo.svg'" [altText]="textkeyPrefix + '.callout.logo.alttext' | translate"></app-advisor-image>
      <p [innerHTML]="textkeyPrefix + 'description' + textkeyPostfix | translate"></p>
    </div>
  </section>


  <section class="cell small-12 large-offset-2 large-8 text-center">
    @if (result !== 'keine_adresse' && result !== 'nein') {
      <h2 [innerHTML]="textkeyPrefix + 'next.step' + textkeyPostfix | translate"></h2>
    }
    <app-moderat-fernwaerme-teaser
      [showBadge]="true"
      [showLogo]="showDistrictTeaserLogo"
      teaserTopic="beratung"
      teaserClass="callout secondary consultancy"
      buttonClass="'inline-arrow-right'"
      [textkeyPrefix]="textkeyPrefix"
      [textkeyPostfix]="textkeyPostfix">
    </app-moderat-fernwaerme-teaser>
  </section>

  @if (result !== 'keine_adresse') {
    <section class="cell small-12 large-offset-2 large-8">
      @if (result !== 'nein') {
        <app-moderat-fernwaerme-teaser
          teaserTopic="brochure"
          teaserClass="brochure"
          imagePath="/gfx/moc/brochure_district_heating.jpg"
          [downloadIcon]="true"
          [textkeyPrefix]="textkeyPrefix"
          [textkeyPostfix]="textkeyPostfix">
        </app-moderat-fernwaerme-teaser>
      }
    </section>

    <section class="cell small-12 large-offset-2 large-8 tipp callout secondary">
      <i class="icon-info"></i>
      <p [innerHTML]="textkeyPrefix + 'info' + textkeyPostfix | translate"></p>
    </section>
}



</div>
}

<app-step-buttons previousLink="../../basisinformationen/2" [nextText]="'moderat.fernwaerme.ergebnis.submit' + textkeyPostfix | translate" nextLink="../../basisinformationen/3" [nextSubmit]="false" mediumOffset="0" mediumWidthRight="0" largeWidthRight="8"></app-step-buttons>

